import { Text } from '@medly-components/core';
import { mapTourActiveElementStyles } from 'pages/Map/components/MapTour/MapTour.styled';
import styled, { css } from 'styled-components';
import { zIndex } from 'theme/zIndex';

export const LabelsWrapper = styled.div`
    min-width: 5.6rem;
    z-index: ${zIndex.SectionWrapper};

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        min-width: 3.2rem;
    }
`;

const tourActiveStyles = css`
    position: relative;
    ${mapTourActiveElementStyles}
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 0;
    &::before {
        border-radius: 0;
    }
`;

export const SectionsLabelWrapper = styled.div<{ isMapTourActiveElement: boolean }>`
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.grey[300]};
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.colors.white};
    display: flex;
    justify-content: center;
    ${({ isMapTourActiveElement }) => isMapTourActiveElement && tourActiveStyles};
`;

export const scalingLabelStyles = css<{ scale: number }>`
    font-size: ${({ scale }) => (scale < 0.3 ? '1rem' : '1.2rem')};
`;

export const SectionLabel = styled(Text)<{ scale: number }>`
    overflow: hidden;
    padding: 0.5rem 0 0.5rem 0.5rem;
    box-sizing: border-box;
    text-align: center;
    width: fit-content;
    height: 100%;
    transform: rotate(180deg);
    writing-mode: vertical-rl;
    line-height: 1;
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    ${({ scale }) => scale < 0.4 && scalingLabelStyles};
`;
